<template>
  <consult-page></consult-page>
</template>

<script>
import ConsultPage from './ConsultPage'
export default {
  name: 'ZhbConsult',
  components: {
    ConsultPage
  },
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/zhb_consult/ZhbConsult.vue